<script>
import axios, { AxiosResponse } from 'axios';
import Vue from 'vue';

export default class MeridianLinkService extends Vue {
  /**
   * This method sends a get request to get all fi configs.
   */
  static getAllConfigs() {
    console.log('Submitting info to get all configs');
    const response = axios.get('/api/meridianlink/config').then(data => data.data);
    return response;
  }

  /**
   * This method sends a post request to add an fi config.
   */
  static postMeridianLinkConfig(payload) {
    const payloadMap = {};
    const keys = Object.keys(payload);
    const values = Object.values(payload);
    for (let i = 0; i < keys.length; i++) {
      payloadMap[keys[i]] = values[i];
    }
    console.log('Submitting info to post config');
    axios.put('/api/meridianlink/config/', payloadMap);
  }

  /**
 * This method sends a delete request to remove a fi config.
 */
  static deleteMeridianLinkConfig(payload) {
    const payloadMap = {};
    const keys = Object.keys(payload);
    const values = Object.values(payload);
    for (let i = 0; i < keys.length; i++) {
      payloadMap[keys[i]] = values[i];
    }
    console.log('Submitting info to delete config');
    axios.put('/api/meridianlink/config/delete', payloadMap);
  }

  /**
 * This method returns the set of states from all ddb entries
 */
  static getStatesList(meridianLinkObjectsList) {
    const statesList = [];

    Object.keys(meridianLinkObjectsList).forEach((idx) => {
      if (!statesList.includes(meridianLinkObjectsList[idx].fiState)) {
        statesList.push(meridianLinkObjectsList[idx].fiState);
      }
    });
    return statesList;
  }
}
</script>
